export const NO_CONTRACTS = "لا يوجد لديك أي معاملات نشطة";
export const START_NEW_CONTRACT = "ابدء معاملة جديدة الآن";
export const PREVIOUS = "previous";
